import React from 'react'
import { Input } from 'antd'
import { View } from 'styles/reactnative'
const { Search } = Input

const AdminSettingSearch = ({ search, searchData }) => {
	return (
		<View style={{ flexDirection: 'row' }}>
			<Search
				defaultValue={search}
				placeholder="검색어를 입력해주세요."
				onSearch={searchData}
				style={{ width: 300, zIndex: 0 }}
			/>
		</View>
	)
}

export default AdminSettingSearch
